/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useLayoutEffect, useState } from 'react';

/**
 * Custom hook that listens to the window resize event and returns updated dimensions of window
 * @returns Array of window's current width and height
 */
export function useWindowSize(): number[] {
  const [size, setSize] = useState([0, 0]);

  const updateSize = useCallback(() => {
    setSize([window.innerWidth, window.innerHeight]);
  }, []);

  useLayoutEffect(() => {
    updateSize();
    window.addEventListener('resize', updateSize);
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}
